import { DataBaseNodes } from '@lib';
import { SocialMediaPost } from '@type';

import { CommunicationKeys, Preferences } from '../types';
import { BaseGateway } from './base.gateway';

export class SocialMediaGateway extends BaseGateway {
  getSocialMediaPosts = async (siteUuid: string, siteId: number) => {
    return await this.dataExchange<{
      data?: SocialMediaPost[];
    }>({
      siteUuid: siteUuid,
      payload: {
        siteId: siteId,
        preference: Preferences.SocialMedia.Getlinks,
      },
      query: DataBaseNodes.Request,
      successKey: CommunicationKeys.SocalMedia.Success,
      failureKey: CommunicationKeys.SocalMedia.Failure,
      pushWithKey: true,
    }).catch(error => {
      throw new Error(
        `Error on getting social media posts: ${JSON.stringify(error)}`
      );
    });
  };
}
